const MAX_SLUG_LENGTH = 48;

/**
 * Vietnamese names are the common case here, so diacritics are stripped rather than
 * dropped — "Phở Ngọc Nga" must become "pho-ngoc-nga", not "ph-ng-nga". The đ/Đ pair
 * needs an explicit replacement because it does not decompose under NFD.
 */
export function deriveSlug(name: string): string {
  const slug = name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[đĐ]/g, (match) => (match === 'đ' ? 'd' : 'D'))
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, MAX_SLUG_LENGTH)
    .replace(/-+$/g, '');

  return slug.length > 0 ? slug : 'organization';
}

export function nextAvailableSlug(base: string, taken: string[]): string {
  const set = new Set(taken);
  if (!set.has(base)) {
    return base;
  }
  let suffix = 2;
  while (set.has(`${base}-${suffix}`)) {
    suffix += 1;
  }
  return `${base}-${suffix}`;
}
